(function () {
  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-rotator]').forEach(function (rotator) {
    var items = rotator.querySelectorAll('[data-rotator-item]');
    if (items.length < 2 || calm) return;
    var index = 0;
    setInterval(function () {
      items[index].hidden = true;
      index = (index + 1) % items.length;
      items[index].hidden = false;
    }, 4000);
  });

  document.querySelectorAll('[data-looz]').forEach(function (root) {
    var data = JSON.parse(root.querySelector('[data-looz-json]').textContent);
    var variants = [].concat.apply([], data.variantGroups);
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-row]'));
    var picker = root.querySelector('[data-picker]');
    var cta = root.querySelector('[data-cta]');
    var atc = root.querySelector('[data-atc]');
    var error = root.querySelector('[data-error]');
    var cartCount = document.querySelector('[data-cart-count]');
    var sizeDialog = root.querySelector('[data-size-dialog]');
    var sticky = root.querySelector('[data-sticky]');
    var stickyPrice = root.querySelector('[data-sticky-price]');
    var stickyButton = root.querySelector('[data-sticky-button]');

    function format(n) { return Number(n).toLocaleString('en-US'); }
    function selectedPack() { return root.querySelector('[data-pack]:checked'); }
    function pack() { return Number(selectedPack().value); }
    function total() { return format(data.totals[pack() - 1]) + ' EGP'; }
    function ctaLabel() { return 'Order now · ' + total(); }
    function find(color, size) {
      return variants.find(function (v) { return v.option1 === color && v.option2 === size; });
    }
    function showError(message) { error.textContent = message; error.hidden = !message; }
    function setBusy(busy) { cta.disabled = busy; atc.disabled = busy; if (stickyButton) stickyButton.disabled = busy; }

    function syncSizes(row) {
      var color = row.querySelector('[data-color]').value;
      var size = row.querySelector('[data-size]');
      Array.prototype.forEach.call(size.options, function (opt) {
        if (!opt.value) return;
        var v = find(color, opt.value);
        opt.disabled = !v || !v.available;
        if (opt.disabled && size.value === opt.value) size.value = '';
      });
    }

    function refresh() {
      var n = pack();
      selectedPack().closest('.lz-pack').after(picker);
      rows.forEach(function (row, i) { row.hidden = i >= n; });
      cta.textContent = ctaLabel();
      if (stickyPrice) stickyPrice.textContent = n + (n === 1 ? ' piece · ' : ' pieces · ') + total();
      showError('');
    }

    function selectedItems() {
      var items = [];
      var missing = false;
      rows.slice(0, pack()).forEach(function (row) {
        var size = row.querySelector('[data-size]');
        if (!size.value) { size.classList.add('lz-missing'); missing = true; return; }
        var v = find(row.querySelector('[data-color]').value, size.value);
        if (v) items.push({ id: v.id, quantity: 1 });
      });
      if (missing) { showError('Please choose a size for each piece.'); return null; }
      return items;
    }

    function addToCart(items) {
      return fetch(data.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (res) {
        if (!res.ok) throw new Error('add failed');
      });
    }

    function fail() {
      setBusy(false);
      cta.textContent = ctaLabel();
      atc.textContent = 'Add to cart';
      showError('Something went wrong and your order was not added. Please try again.');
    }

    function updateCartCount() {
      return fetch('/cart.js').then(function (res) { return res.json(); }).then(function (cart) {
        if (cartCount) cartCount.textContent = cart.item_count;
      });
    }

    rows.forEach(function (row) {
      syncSizes(row);
      row.querySelector('[data-color]').addEventListener('change', function () { syncSizes(row); });
      row.querySelector('[data-size]').addEventListener('change', function (e) {
        e.target.classList.remove('lz-missing');
        showError('');
      });
    });
    root.querySelectorAll('[data-pack]').forEach(function (r) { r.addEventListener('change', refresh); });

    var track = root.querySelector('[data-track]');
    if (track) {
      var slides = Array.prototype.slice.call(track.children);
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
      var counter = root.querySelector('[data-counter]');
      var current = 0;
      var mark = function (i) {
        current = i;
        thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
        if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
      };
      var go = function (i) {
        var next = (i + slides.length) % slides.length;
        track.scrollTo({ left: slides[next].offsetLeft - track.offsetLeft, behavior: calm ? 'auto' : 'smooth' });
        mark(next);
      };
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var i = Math.round(track.scrollLeft / track.clientWidth);
          if (i !== current && slides[i]) mark(i);
        });
      });
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
      var prev = root.querySelector('[data-prev]');
      var next = root.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', function () { go(current - 1); });
      if (next) next.addEventListener('click', function () { go(current + 1); });
    }

    if (sticky && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        sticky.hidden = entries.some(function (entry) { return entry.isIntersecting; });
      }, { threshold: 0.2 });
      observer.observe(cta);
    }
    if (stickyButton) {
      stickyButton.addEventListener('click', function () {
        var missing = rows.slice(0, pack()).some(function (row) { return !row.querySelector('[data-size]').value; });
        if (missing) {
          selectedItems();
          picker.scrollIntoView({ block: 'center', behavior: calm ? 'auto' : 'smooth' });
          return;
        }
        atc.click();
      });
    }

    if (sizeDialog) {
      root.querySelector('[data-size-open]').addEventListener('click', function () { sizeDialog.showModal(); });
      root.querySelector('[data-size-close]').addEventListener('click', function () { sizeDialog.close(); });
    }

    atc.addEventListener('click', function () {
      var items = selectedItems();
      if (!items) return;
      showError('');
      setBusy(true);
      atc.textContent = 'Adding...';
      addToCart(items).then(function () {
        setBusy(false);
        atc.textContent = 'Add to cart';
        document.dispatchEvent(new CustomEvent('looz:cart-added'));
      }).catch(fail);
    });

    root.querySelector('[data-form]').addEventListener('submit', function (e) {
      e.preventDefault();
      var items = selectedItems();
      if (!items) return;
      setBusy(true);
      cta.textContent = 'One moment...';
      addToCart(items).then(function () {
        window.location.href = '/checkout';
      }).catch(fail);
    });

    updateCartCount();
    refresh();
  });
})();
